function setAuthToken(token){
  localStorage.setItem('click2giv_site_token', token);
}

function getAuthToken(){
  return localStorage.getItem('click2giv_site_token');
}

function getHeaders(){
  return {
    "Authorization": getAuthToken() 
  }
}

function isAuth(){
  if(localStorage.getItem('click2giv_site_token')!== null){
    return true;
  }
  return false;
}

function logout(){
  localStorage.removeItem('click2giv_site_token');
}

module.exports = {
  setAuthToken,
  getAuthToken,
  isAuth,
  getHeaders,
  logout
}


// WEBPACK FOOTER //
// ./src/services/auth.js